import React from 'react';
import { Link } from 'react-router-dom';

import BubbleQuestionMarkIcon from 'components/Common/Icons/BubbleQuestionMark';
import Trans from 'components/Common/Translation/Trans';
import { getUri } from 'services/generic';

import styles from './NeedSupport.module.scss';

export default function NeedSupport(): JSX.Element {
  return (
    <p className={styles.paragraph}>
      <span className={styles.icon}>
        <BubbleQuestionMarkIcon />
      </span>
      <Link to={getUri('/personal-account-support')} className={styles.link}>
        <Trans
          i18nKey={'PERSONAL_ACCOUNT_NEED_HELP'}
          additionalComponents={{
            underline: <span className={styles.underline} />,
          }}
        />
      </Link>
    </p>
  );
}
